<template>
  <v-footer
    :class="['foot-glass', { 'foot-login': isLogin }]"
    app
    :inset="false"
  >
    <v-container class="py-2 px-4">
      <v-row align="center" justify="space-between" no-gutters>
        <v-col cols="12" md="8" class="foot-left text-center text-md-left">
          <span class="foot-brand">Powered by Intrare</span>
          <span class="foot-divider">|</span>
          <span class="foot-company">TECNOLOGIAS EN ACCESOS CONTROLADOS SA DE CV</span>
          <span class="foot-divider">|</span>
          <span class="foot-year">{{ currentYear }}</span>
        </v-col>
        <v-col cols="12" md="4" class="text-center text-md-right mt-1 mt-md-0">
      <a style="color: #dddddd;font-size:10px;" href="https://test-club.intrare.app/notice_privacy_club" target="_blank">Aviso de privacidad Club</a>&nbsp;&nbsp;&nbsp; <a style="color: #dddddd;font-size:10px;" href="https://test-club.intrare.app/notice_privacy" target="_blank">Aviso de privacidad</a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Foot',
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.foot-glass {
  background: rgba(12, 27, 46, 0.42) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(10px);
}

.theme--light.v-footer.foot-login,
.theme--dark.v-footer.foot-login,
.v-footer.foot-login {
  background-color: #43a047 !important;
  background: #43a047 !important;
  border-top: none !important;
  backdrop-filter: none;
}

.foot-left {
  color: #f4f8fb;
  font-size: 11px;
  line-height: 1.4;
}

.foot-brand {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.foot-company,
.foot-year {
  opacity: 0.92;
}

.foot-divider {
  display: inline-block;
  margin: 0 8px;
  opacity: 0.5;
}

.foot-link {
  color: #d8e9ef;
  font-size: 11px;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.foot-link:hover {
  color: #ffffff;
  border-bottom-color: rgba(255, 255, 255, 0.78);
}

@media (max-width: 960px) {
  .foot-left {
    font-size: 10px;
  }

  .foot-divider {
    margin: 0 5px;
  }

  .foot-link {
    font-size: 10px;
  }
}

</style>
